module.exports = __webpack_public_path__ + "assets/default-d2a555.svg";